import { Dialog, DialogContent } from '@/common/ui/dialog'
import { Spinner } from '@/common/ui/spinner'

interface LoadingOverlayProps {
	open: boolean
	message?: string
}

export default function LoadingOverlay({
	open,
	message = 'กำลังดำเนินการ...',
}: LoadingOverlayProps) {
	return (
		<Dialog open={open}>
			<DialogContent className="max-w-sm border-none bg-transparent shadow-none [&>button]:hidden">
				<div className="flex flex-col items-center justify-center gap-4 rounded-lg bg-background/95 p-8 shadow-lg backdrop-blur-sm">
					<div className="relative">
						<Spinner className="h-8 w-8 text-primary" />
						<div className="absolute inset-0 h-8 w-8 animate-ping rounded-full bg-primary/20" />
					</div>
					<p className="text-sm font-medium text-foreground">{message}</p>
				</div>
			</DialogContent>
		</Dialog>
	)
}
